export const timeoutAfter = <E, T>(
  ms: number,
  error: E,
  promise: Promise<T>
) => {
  const timeoutPromise = new Promise((_resolve, reject) =>
    setTimeout(() => reject(error), ms)
  );

  return Promise.race([timeoutPromise, promise]);
};
